import { useQuery } from '@tanstack/react-query';
import axios, { AxiosError } from 'axios';
import { queryKeys } from '../../shared';
import { IReport } from '../models';
import * as Sentry from '@sentry/react';

async function getReport(id: string): Promise<IReport> {
    const { data } = await axios.get(`/reporting/reports/${id}`);
    if (data.columns === undefined) {
        Sentry.captureMessage(`Report ${id} has no columns: ${JSON.stringify(data)}`);
    }
    return data;
}

export const useReport = (id: string) => {
    return useQuery<IReport, AxiosError>({ queryKey: [queryKeys.REPORT, id], queryFn: () => getReport(id) });
};
